import * as React from 'react'

type ColumnStyle = Record<
  `--sticky-column-width-${number}` | `--sticky-offset-left-${number}`,
  string
>

interface IUseStickyColumnsCss {
  columnsStyle?: ColumnStyle
}

export const useStickyColumnsStyle = ({
  numberOfStickyColumns,
  wrapperRef
}: {
  numberOfStickyColumns: number
  wrapperRef: React.RefObject<HTMLDivElement | null>
}): IUseStickyColumnsCss => {
  const [columnsStyle, setColumnsStyle] = React.useState<ColumnStyle>({})

  const generateColumnsStyle = React.useCallback(() => {
    let accWidth = 0

    // Getting the table header cells elements to use their width to set the left position in the sticky columns.
    const tableHeaderCells = wrapperRef.current?.querySelectorAll('th')
    const tableHeaderElements = Array.from(tableHeaderCells || [])

    // Getting only the number of sticky columns from the elements array that is what we are interested in.
    const stickyColumns = tableHeaderElements.slice(0, numberOfStickyColumns)

    const newColumnsStyle = stickyColumns.reduce((acc, column, index) => {
      const elementNumber = index + 1
      const styleObject = {
        ...acc,
        [`--sticky-column-width-${elementNumber}`]: `${column.offsetWidth}px`,
        [`--sticky-offset-left-${elementNumber}`]: `${accWidth}px`
      }

      accWidth += tableHeaderCells?.item(index).clientWidth || 0

      return styleObject
    }, {})

    return newColumnsStyle
  }, [numberOfStickyColumns, wrapperRef])

  React.useLayoutEffect(() => {
    if (!numberOfStickyColumns) return
    const newColumnsStyle = generateColumnsStyle()

    setColumnsStyle(newColumnsStyle)
  }, [numberOfStickyColumns, wrapperRef, generateColumnsStyle])

  return {
    columnsStyle
  }
}
